import React from 'react';
import PropTypes from 'prop-types';
import {
  FloatingLabelInput as Input,
  FloatingLabelSelect as Select
} from '../../../Elements';
import styles from './TermsBuilder.scss';
import states from '../../../../lib/utils/states';

const Geo = ({ contractVariables, stateFieldChange, textFieldChange }) =>
  <div>
    <h3>What state are you located in?</h3>
    <Select
      name='state'
      value={contractVariables.state}
      type='select'
      onChange={stateFieldChange}
      placeholder='Select State...'
      options={states}
      required
      inline
      style={{ minWidth: '85px' }}
      search
      validationError='Required'
    />
    <h3>What county are you located in?</h3>
    <Input
      name='county'
      type='text'
      inline
      required
      placeholder='Orange'
      validationError='Required'
      value={contractVariables.county}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>County</div>
  </div>;

Geo.propTypes = {
  contractVariables: PropTypes.object.isRequired,
  stateFieldChange: PropTypes.func.isRequired,
  textFieldChange: PropTypes.func.isRequired
};

export default Geo;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/Geo.js